import { CSSInterpolation } from '@ant-design/cssinjs'
import { GlobalToken } from 'antd'

export const genLayoutStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => {
  // const a = theme.getDesignToken()
  // console.log('token', JSON.stringify(token))
  return [
    {
      [`.${prefixCls}`]: {
        height: '100%',
        [`&.collapsed`]: {
          [`.slider`]: {
            width: 52,

            [`.logo h1`]: {
              fontSize: 0,
              paddingLeft: 10,
            },

            //
            '.ant-menu .ant-menu-item .ant-menu-item-icon': {
              verticalAlign: '-0.3em',
            },
            '.ant-menu-inline .ant-menu-item, .ant-menu-vertical .ant-menu-item, .ant-menu-inline .ant-menu-submenu-title, .ant-menu-vertical .ant-menu-submenu-title':
              {
                paddingInline: 'calc(50% - 12px - 6px)',
              },
            '.ant-menu-inline-collapsed >.ant-menu-item .ant-menu-item-icon': {
              // width: 16,
              // height: 16,
            },
            '.ant-menu-submenu-selected >.ant-menu-submenu-title': {
              backgroundColor: 'rgb(54, 71, 199)',
            },
          },
          '.layout': {
            marginLeft: 52,
            width: 'calc(100vw - 52px)',
          },
        },

        [`.slider`]: {
          backgroundColor: '#1D1E24',
          height: '100%',
          width: 230,
          position: 'fixed',
          left: 0,
          display: 'flex',
          flexDirection: 'column',
          transition: 'width 300ms',
          zIndex: 2,
          userSelect: 'none',
          '.ant-menu-item .ant-menu-item-icon': {
            width: 24,
            height: 24,
            transition: 'all 300ms',
          },
          '.ant-menu-inline .ant-menu-submenu-title': {
            paddingInline: 8,
            paddingLeft: 8,
          },
          '.ant-menu-item-icon': {
            flexShrink: 0,
          },
          '.ant-menu-vertical >.ant-menu-submenu>.ant-menu-submenu-title': {
            display: 'flex',
            alignItems: 'center',
          },
          '.ant-menu-submenu-title': {
            ':hover': {
              color: '#fff',
            },
          },
          '.ant-menu-item': {
            fontSize: 14,
          },
          '.submenu-root>.ant-menu-submenu-title, .submenu-root>.ant-menu-title-content':
            {
              fontSize: 16,
            },

          '.ant-menu-submenu-open.ant-menu-submenu-inline>.ant-menu-submenu-title>.ant-menu-submenu-arrow':
            {
              transform: 'translateY(-50%)',
            },

          [`.logo`]: {},

          [`.menu`]: {
            flex: 1,
            overflow: 'auto',
          },
        },
        [`.layout`]: {
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          background: token.colorBgLayout,
          marginLeft: 230,
          transition: 'margin 300ms',

          [`.header`]: {
            flexShrink: 0,
            position: 'sticky',
            top: 0,
            zIndex: 3,
            borderBottom: '1px solid #eeeef3',

            [`.tools`]: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: '#fff',
              padding: '0 16px',
              height: 48,
              flexShrink: 0,

              [`.global-tips`]: {
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
                gap: 8,
                zIndex: 999999,
                padding: 8,
                color: '#D54941',
                fontWeight: 600,
                fontSize: 14,
                userSelect: 'none',
              },

              [`.userinfo`]: {
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                flexShrink: 0,
              },

              [`.button-collapse`]: {
                cursor: 'pointer',
              },
            },

            [`.breadcrumb`]: {
              padding: '8px 16px',
            },
          },

          [`.content`]: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          },
        },
      },
    },
  ]
}

export const genIconStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => [
  {
    [`.${prefixCls}`]: {
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      padding: '24px 12px',
      cursor: 'pointer',
      // color: '#0D1121',
    },
  },
]

export const genUserInfoStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => [
  {
    [`.${prefixCls}`]: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      borderRadius: '100px',
      background: '#FFF0F0',
      padding: '7px 12px',
      cursor: 'pointer',
      color: '#0D1121',
      fontSize: 12,
      fontWeight: 500,
    },
  },
]

export const genUserInfoMenuItemStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => [
  {
    [`.${prefixCls}`]: {
      backgroundColor: '#FFFFFF',
      padding: '24px',
      borderRadius: '4px',
      boxShadow: '0px 0px 4px 0px #DFE9FA, 0px 4px 8px 0px #6D86A31A',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      '.user-info-all': {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        [`.user-info`]: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
          gap: '8px',
          '.org-path-name': {
            fontSize: '14px',
            fontWeight: 500,
            color: '#3D414D',
          },
          [`.user-name`]: {
            fontSize: '18px',
            fontWeight: 500,
            color: '#0D1121',
          },
          [`.user-post-name, .user-phone`]: {
            fontSize: '12px',
            fontWeight: 400,
            color: '#6E707A',
          },
        },
      },
    },
  },
]
